import React from 'react';
import './products.css'
import cookie from 'react-cookies';

import Topbar2 from "../../component/topbar2"
import { requestGet, requestPost, getAllUrlparameter} from '../../component/functions';
import { Row, Col, Input, Button, List, Spin, Skeleton,Modal,message,Popover} from 'antd';
import { QuestionCircleOutlined ,CloseCircleTwoTone,CheckCircleTwoTone} from '@ant-design/icons';

const { Search } = Input;

class Artkey extends React.Component {
  constructor(props) {
    //父组件传入参数
    super(props);
    //当前组件状态
    this.state = {
      mobile:false,

      hotarts: [],            //热门文章
      newArts: [],            //最新文章

      notLoggedModal:false,       //未登录标记
      loading: false,          //是否搜索中
      requestdone:false,          //request是否已完成
      artkeywordsloading: false,   //关联词搜索中

      jwt: "none",

      //搜索关键词
      searchkey: "",
      //关联词列表
      artkeywords: [],
      //结果文章列表
      artlist: [],
      //分页数据
      pagination: {
          //当前页数
          cutpage: 1,
          //总页数   
          totalpage: 1,
      },
    }
  };

  componentDidMount() {
    // 检查cookie
    if (cookie.load("jwt_v2") !== undefined) {
      this.setState({
        jwt: cookie.load("jwt_v2")
      });
    }

    this.deviceCheck();             //用户设备检查
    this.searchFromIndex();

    if(!this.state.mobile){         //PC端获取
        this.getHotarts();
        this.getNewarts();
    }
  }

  // 设备检查，若屏幕宽度小于500，或url传参applet=true，判定为移动端
  // 工具需要使用jwt，暂未做登录页的移动端适配吗，因此屏蔽屏幕<500的移动适配，url传参会带jwt
  deviceCheck = () =>{
    if(getAllUrlparameter()["applet"] ==="1"){
      this.setState({
        mobile:true,
        jwt:getAllUrlparameter()['jwt']
      });
    }

    if(window.screen.width <= 500){
      this.setState({
        mobile:true,
        jwt:getAllUrlparameter()['jwt']
      });
    }
  }

  // 从首页直接搜索，从url获取参数
  searchFromIndex = () =>{
      let content = getAllUrlparameter()["content"]
      if(content !== undefined){this.search(content);}
  }
    

  // 获取热文
  getHotarts = () => {
    let url = "https://gateway1.moxidata.cn/mktcharts/artkeywords/?method=hotfile_encrypt";
		requestGet(url).then((data) => {
			if(data.error ===1){
		    this.setState({
		     hotarts: data.records,			
		    })
			}else{
		    this.setState({		        
		     hotarts:[],  
		    })
			}
		});
  }

  // 获取最新文章
  getNewarts = () => {
    let url = "https://gateway1.moxidata.cn/mktcharts/artkeywords/?method=news";

    requestGet(url).then((data) => {
      if (data.error) {
        this.setState({
          newArts: data.records,
        });
      }
    });
  }

    // 搜索文章
    requestartlist() {
        this.setState({ loading: true })

        let ary_words = this.state.searchkey.split(" ");
        for (var i = 0; i < ary_words.length; i++) {
            if (ary_words[i] === "") {
                ary_words.splice(i, 1);
                i--;
            }
        }
        let url = "https://gateway1.moxidata.cn/mktcharts/artkeywords/";
        let formdata = new FormData();
        formdata.append("method", "artical_query")
        formdata.append("jwt", this.state.jwt)
        formdata.append("int_art_page", this.state.pagination.cutpage)
        Object.keys(ary_words).forEach((e, i) => {
            formdata.append(`ary_q_tags[]`, ary_words[e])
        })

        requestPost(url, formdata).then((data) => {
            // console.log("search result artlist", data)
            this.setState({ loading: false })
            if (data.error === 1) {
                this.setState({
                    artlist: data.artlist,
                    requestdone:true,
                    pagination: {
                        cutpage: data.cutpage,
                        totalpage: data.totalpage,
                    }
                })
            }else{
                this.setState({
                    artlist:[],
                    requestdone:true,
                    pagination: {
                        cutpage: 1,
                        totalpage: 1,
                    }
                })
            }
        })
    }

    // 搜索关联词
    requestartkeywords() {
        let that = this;
        this.setState({ artkeywordsloading: true })

        let ary_words = this.state.searchkey.split(" ");
        for (var i = 0; i < ary_words.length; i++) {
            if (ary_words[i] === "") {
                ary_words.splice(i, 1);
                i--;
            }
        }
        let url = "https://gateway1.moxidata.cn/mktcharts/artkeywords/";
        let formdata = new FormData();
        formdata.append("method", "cilian_artkeywords")
        formdata.append("jwt", that.state.jwt)
        formdata.append("int_tag_page", 1)
        Object.keys(ary_words).forEach((e, i) => {
            formdata.append(`ary_q_tags[]`, ary_words[e])
        })

        requestPost(url, formdata).then((data) => {
            // console.log("search result artkeywords", data)

            if (data.error === 1) {
                this.setState({
                    artkeywords: data.tags_weibo_index,
                    artkeywordsloading: false,
                })
            }else{
                this.setState({
                    artkeywords:[],
                    artkeywordsloading: false,
                })
            }
        })
    }

    // 输入框内容改变
    changeinput = (e) => {
        // console.log(e)
        this.setState({
            searchkey: e.target.value
        })
    }

    // 搜索框
    search = (e) => {
      // console.log("e", e)
      if (e !== "") {
        if (this.state.jwt !== "none") {
          this.setState({
            searchkey: e,
          });
          this.requestartlist()
          this.requestartkeywords()
        } else {
          // alert("请登录后使用！")
          this.setState({notLoggedModal:true})
        }
      }
    }

    // 点击关联词搜索
    cilianbtn = (e) => {
        // console.log(e.currentTarget.dataset.name)
      this.setState({
        searchkey: e.currentTarget.dataset.name,
      });
      this.requestartlist()
      this.requestartkeywords()
    }

    // 加载下一页文章
    showMoreArt = () => {
      if (this.state.pagination.cutpage < this.state.pagination.totalpage) {
        const newCutPate = this.state.pagination.cutpage + 1;
        this.setState({
          cutpage: newCutPate,
        });
        this.requestartlist();

      } else {
          // alert("没有更多了！")
          message.info('没有更多了！');
		
      }
    }


    render() {
      if(!this.state.mobile){
        //PC端渲染
        const JSXArtpush = <Row className='artkey-artsbody' justify='space-between'>
          <Col className='artkey-artsitem'>
              <div className='artkey-artsitem-title'>近期热文</div>
              <div className='artkey-hotarts-list'>
                {this.state.hotarts.map((e, i) => {
                    return (
                        <Row key={i} justify="space-between" wrap={false}>
                            <Col className='artkey-artname'><a href={e.art_link} target="_blank" rel="noreferrer" className='artkey-artlink'>{e.artname}</a></Col>
                            <Col className='artkey-arttime'>{e.art_edittime}</Col>
                        </Row>
                    )
                })}
              </div>
          </Col>

          <Col className='artkey-artsitem'>
              <div className='artkey-artsitem-title'>最新文章</div>
              <div className='artkey-hotarts-list'>
                {this.state.newArts.map((e, i) => {
                  return (
                      <Row key={i} justify="space-between" wrap={false}>
                          <Col className='artkey-artname'><a href={e.art_link} target="_blank" rel="noreferrer" className='artkey-artlink'>{e.art_name}</a></Col>
                          <Col className='artkey-arttime'>{e.strdate.slice(0, 10)}</Col>
                      </Row>
                  )
                })}
              </div>
          </Col>
        </Row>

          const JSXSearch = <Row className='artkey-search-body'>
                  <Popover content={
                      <div>
                          <div>1.请使用简短关键词，勿搜索长句子</div>
                          <div>2.多个关键词使用空格隔开</div>
                          <div>&nbsp;</div>
                          <div>错误示例：<CloseCircleTwoTone twoToneColor="#eb2f96"/>迪士尼的净利润是多少</div>
                          <div>正确示例：<CheckCircleTwoTone twoToneColor="#52c41a"/>迪士尼 净利润</div>


                      </div>
                  } title="搜索指南">
                      <QuestionCircleOutlined id="artkey_Search_Tips" />
                  </Popover>
                  <Search id='searchInput' placeholder="请输入简短的关键词，多个关键词使用空格隔开，例如：迪士尼 净利润" size="large" value={this.state.searchkey} onChange={this.changeinput} allowClear onSearch={this.search} loading={this.state.loading} enterButton="搜索" />
                  <Row>
                      {this.state.artkeywords.length > 0 && <span style={{color:"white"}}>关联概念/关联词(微博指数)：</span>}
                      {
                          this.state.artkeywordsloading ? <Spin /> :
                              this.state.artkeywords.map((e, i) => {
                                  return <Button key={i} className='artkey-artkeywords-btn' size='small' onClick={this.cilianbtn} data-name={Object.keys(e)[0]}>
                                      {Object.keys(e)[0]}
                                      {'\u00A0'}
                                      <svg t="1659072405055" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2058" width="12px" height="12px"><path d="M494.933333 968.9088c251.357867 0 455.133867-203.776 455.133867-455.133867 0-108.509867-31.744-213.8112-101.376-286.378666-64.853333-67.584-136.055467 219.818667-200.9088 190.395733-57.275733-26.0096-31.300267-370.4832-112.7424-370.4832-81.476267 0-168.618667 381.883733-227.259733 409.429333-64.9216 30.481067-87.04-324.8128-171.281067-223.470933-62.7712 75.502933-96.699733 174.6944-96.699733 280.507733 0 251.357867 203.776 455.133867 455.133866 455.133867z" fill="#FF6B35" p-id="2059"></path><path d="M494.933333 968.9088c57.275733 0 112.4352-10.274133 162.679467-30.3104 5.973333-2.389333 35.703467-62.6688-67.1744-137.8304-109.6704-80.042667-64.853333-241.4592-117.248-241.4592-52.4288 0-85.640533 77.789867-149.265067 164.010667-59.904 81.2032-75.434667 171.451733-67.140266 176.469333 70.109867 42.734933 150.698667 69.12 238.148266 69.12z" fill="#FFAF1D" p-id="2060"></path></svg>
                                      {e[Object.keys(e)[0]] === "无相关微博指数" ? "无" : e[Object.keys(e)[0]]}
                                  </Button>
                              })
                      }
                  </Row>
              </Row>

          const JSXResult = (
              this.state.loading ? 
                  <div className='artkey-serachresult-body'><Skeleton active={true} /><Skeleton active={true} /></div> 
                  :
                  <div className='artkey-serachresult-body'>
                      <List
                          dataSource={this.state.artlist}
                          renderItem={(item) => (
                              <List.Item>
                                  <List.Item.Meta
                                      description={
                                          <div>
                                              <Row style={{ minHeight: "50px" }} wrap={false} align="middle">
                                                  <Col className='artkey-searchresult-item-name'>{item.art_name}</Col>
                                                  <Col className='artkey-searchresult-item-funs'>{item.art_edittime.slice(0, 16)}</Col>
                                                  <Col className='artkey-searchresult-item-funs'><Button href={item.art_link} target="_blank">查看原文</Button></Col>
                                              </Row>
                                          </div>
                                      }
                                  />
                              </List.Item>
                          )}
                      />
                      {this.state.artlist.length>0 && <Row justify='center' style={{ margin: "30px" }}><Button onClick={this.showMoreArt} size="large" loading={this.state.loading}>换一批</Button></Row> }
                  </div>
              )


          const JSXNotLoggedModal = 
              <Modal title="未登录" cancelText="关闭" okText="登录/免费注册" visible={this.state.notLoggedModal} onOk={()=>{this.setState({notLoggedModal:false});window.location.href="/forest/login"}} onCancel={()=>{this.setState({notLoggedModal:false})}}>
                  <p>本工具完全免费</p>
                  <p>请在登录 / 免费注册后使用！</p>
              </Modal>


          return (
              <div style={{ minWidth: "1200px" }}>
                  {JSXNotLoggedModal}
                  <Topbar2 pagetitle="文章敲敲乐" />

                  <Row className='artkey-funbody'>
                      {JSXArtpush}
                      {JSXSearch}
                      {(this.state.requestdone || this.state.loading) &&JSXResult}
                  </Row>
              </div>
          );

      }else{
      //移动端渲染
          const JSXSearch = <Row className='artkey-search-body'>
                  <Search id='searchInput' placeholder="请输入简短的关键词，多个关键词使用空格隔开" size="large" value={this.state.searchkey} onChange={this.changeinput} allowClear onSearch={this.search} loading={this.state.loading} enterButton="搜索" />
                  <Row>
                      {this.state.artkeywords.length > 0 && <span style={{color:"white"}}>关联概念/关联词(微博指数)：</span>}
                      {
                          this.state.artkeywordsloading ? <Spin /> :
                              this.state.artkeywords.map((e, i) => {
                                  if(i<5){
                                  return <Button key={i} className='artkey-artkeywords-btn' size='small' onClick={this.cilianbtn} data-name={Object.keys(e)[0]}>
                                      {Object.keys(e)[0]}
                                      {'\u00A0'}
                                      <svg t="1659072405055" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2058" width="12px" height="12px"><path d="M494.933333 968.9088c251.357867 0 455.133867-203.776 455.133867-455.133867 0-108.509867-31.744-213.8112-101.376-286.378666-64.853333-67.584-136.055467 219.818667-200.9088 190.395733-57.275733-26.0096-31.300267-370.4832-112.7424-370.4832-81.476267 0-168.618667 381.883733-227.259733 409.429333-64.9216 30.481067-87.04-324.8128-171.281067-223.470933-62.7712 75.502933-96.699733 174.6944-96.699733 280.507733 0 251.357867 203.776 455.133867 455.133866 455.133867z" fill="#FF6B35" p-id="2059"></path><path d="M494.933333 968.9088c57.275733 0 112.4352-10.274133 162.679467-30.3104 5.973333-2.389333 35.703467-62.6688-67.1744-137.8304-109.6704-80.042667-64.853333-241.4592-117.248-241.4592-52.4288 0-85.640533 77.789867-149.265067 164.010667-59.904 81.2032-75.434667 171.451733-67.140266 176.469333 70.109867 42.734933 150.698667 69.12 238.148266 69.12z" fill="#FFAF1D" p-id="2060"></path></svg>
                                      {e[Object.keys(e)[0]] === "无相关微博指数" ? "无" : e[Object.keys(e)[0]]}
                                  </Button>
                                  }
                              })
                      }
                  </Row>
              </Row>

          const JSXResult = (
              this.state.loading ? 
                  <div className='mobile-artkey-serachresult-body'><Skeleton active={true} style={{padding:"20px"}} /><Skeleton active={true} /></div> 
                  :
                  <div className='mobile-artkey-serachresult-body'>
                      <List
                          dataSource={this.state.artlist}
                          renderItem={(item) => (
                              <List.Item>
                                  <List.Item.Meta
                                      description={
                                          <div>
                                              <Row justify='space-between' align="middle">
                                                  <Col span={24} className='mobile-artkey-searchresult-item-name'>{item.art_name}</Col>
                                                  <Col className='mobile-artkey-searchresult-item-funs'>{item.art_edittime.slice(0, 16)}</Col>
                                              </Row>
                                          </div>
                                      }
                                  />
                              </List.Item>
                          )}
                      />
                      {this.state.artlist.length>0 && <Row justify='center' style={{ margin: "30px" }}><Button onClick={this.showMoreArt} size="large" loading={this.state.loading}>换一批</Button></Row> }
                  </div>
              )

          return(
              <div className="mobile-artkey-funbody">
                  <Row justify='center'><Col className='mobile-products-pagetitle'>文章敲敲乐</Col></Row>
                  <Row style={{marginTop:this.state.requestdone?"20px":"30vh",transition:".5s"}}>{JSXSearch}</Row>
                  {!this.state.requestdone &&<Row style={{width:"80%",color:"white",margin:"auto"}}>已经厌倦到各个平台搜刮灵感了？快来试试网罗全网文旅资讯的头号AI平台~</Row>}
                  {(this.state.requestdone || this.state.loading) &&JSXResult}
              </div>
          )
      }

    }

}

export default Artkey;